import { render, staticRenderFns } from "./WidgetTable.vue?vue&type=template&id=354a5849&scoped=true"
import script from "./WidgetTable.vue?vue&type=script&lang=js"
export * from "./WidgetTable.vue?vue&type=script&lang=js"
import style0 from "./WidgetTable.vue?vue&type=style&index=0&id=354a5849&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354a5849",
  null
  
)

export default component.exports